export default "__VITE_ASSET__DIhO_cAp__"